/** 섹션 라이브러리 좌측 목록의 sectionType 그룹핑 헬퍼 (순수 함수 — React 의존 없음). */
import type { SectionDesign } from './types'

export interface SectionGroupData {
  sectionType: string
  items: SectionDesign[]
}

/**
 * sectionType별로 묶는다.
 * 그룹 순서 = 멤버의 최소 sortOrder, 동률이면 sectionType 사전순.
 * 그룹 내 순서는 입력 배열 순서를 그대로 보존한다
 * (호출부가 sortOrder → name 으로 이미 정렬하므로 여기서 재정렬하지 않는다).
 */
export function groupBySectionType(sections: SectionDesign[]): SectionGroupData[] {
  const groups = new Map<string, SectionDesign[]>()
  for (const s of sections) {
    const items = groups.get(s.sectionType)
    if (items) items.push(s)
    else groups.set(s.sectionType, [s])
  }

  return [...groups.entries()]
    .map(([sectionType, items]) => ({
      sectionType,
      items,
      minSortOrder: Math.min(...items.map((i) => i.sortOrder)),
    }))
    .sort((a, b) => a.minSortOrder - b.minSortOrder || a.sectionType.localeCompare(b.sectionType))
    .map(({ sectionType, items }) => ({ sectionType, items }))
}

/**
 * localStorage에 저장된 "접힌 sectionType" 목록을 파싱한다.
 * 손상된 값(비JSON·배열 아님·비문자열 요소)은 조용히 무시 → 빈 집합 = 전체 펼침.
 */
export function parseCollapsedTypes(raw: string | null): Set<string> {
  if (!raw) return new Set()
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return new Set()
    return new Set(parsed.filter((v): v is string => typeof v === 'string'))
  } catch {
    return new Set()
  }
}
